<template>
  <div class="install-ly">
    <a-card :bordered="false">
      <Breadcrumb routeName="ServiceList" toName="服务详情" goPathName="全部服务"></Breadcrumb>
      <a-card>
        <img class="detail-image" :src='serviceDetail.serverLogo'/>
        <div class="s-detail-content-box">
          <detail-list :col="1">
            <detail-list-item>
              <div class="title">{{ serviceDetail.serverName }}</div>
            </detail-list-item>
            <detail-list-item>
              <div class="content-text">{{ serviceDetail.serverBright }}</div>
            </detail-list-item>
            <detail-list-item>
              <span class="item-name">价格</span>
              <span class="price">￥{{ totalPrice }}</span>
            </detail-list-item>
            <detail-list-item term="">
              <span class="item-name">版本</span>
              <a-radio-group v-model="server" @change="changeServerVersion(server)" buttonStyle="solid">
                <a-radio-button
                  v-for="(item,index) in serviceDetail.serverPrices"
                  :key="index"
                  :value="index">{{ item.serverVersion }}
                </a-radio-button>
              </a-radio-group>
            </detail-list-item>
            <detail-list-item term="">
              <span class="item-name">周期</span>
              <a-radio-group v-model="ser" @change="changeServerCycle(ser)" buttonStyle="solid">
                <a-radio-button
                  v-for="(item,index) in moth"
                  :key="index"
                  :value="index">{{ item.serverCycle }}个月
                </a-radio-button>
              </a-radio-group>
            </detail-list-item>
            <detail-list-item>
              <a-button type="primary" @click="buyEvent">购买</a-button>
            </detail-list-item>

          </detail-list>
        </div>
      </a-card>
      <a-card :headStyle="{padding:'10px 0'}" :bodyStyle="{padding:'10px 0'}" :bordered="false" title="服务详情">
        <div>
          <div v-html="serviceDetail.serverInfo"></div>
        </div>
      </a-card>
      <a-card :bordered="false" :headStyle="{padding:'10px 0'}" :bodyStyle="{padding:'10px 0'}" title="使用教程">
        <div>
          <div v-html="serviceDetail.serverTutorial"></div>
        </div>
      </a-card>

    </a-card>
    <a-modal
      title="微信支付"
      :visible="visible"
      @cancel="handleCancel"
      :destroyOnClose='true'
      :footer="null"
    >
      <img class="imgCode" v-if="imgPath" :src='imgPath'/>
      <p v-if="imgPath" class="imgText">请扫描二维码支付</p>
    </a-modal>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'

export default {
  name: 'ServiceDetail',
  components: {
    Breadcrumb: Breadcrumb
  },
  data() {
    return {
      serverId: 0,
      serviceDetail: '',
      serviceVersionId: 0,
      server: 0,
      ser: 0,
      totalPrice: '',
      moth: [],
      serverCycleIndex: 0,
      visible: false,
      imgPath: '',
      orderId: 0,
      timer: null
    }
  },
  activated() {
    this.serverId = this.$route.query.serverId
    this.getServiceDetail()
    this.server = 0
    this.ser = 0
  },
  deactivated() {
    this.clearTimeout()
  },
  mounted() {
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.clearTimeout()
    },
    // 获取数据
    getServiceDetail() {
      this.getHttpServices().getServerApiService().get('info/getServerInfo', { serverId: this.serverId }).then(res => {
        this.serviceDetail = res
        this.serviceVersion = res.serverPrices
        this.moth = res.serverPrices[0].serverPriceAndCycles
        this.totalPrice = res.serverPrices[0].serverPriceAndCycles[0].serverPrice
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 购买
    buyEvent(e) {
      let option = this.serviceDetail.serverPrices[this.server].serverPriceAndCycles[this.ser]
      this.getHttpServices().getServerApiService().post('order/addServerOrder', {
        merchantId: this.$store.getters.userInfo.merchantId,
        orderCycle: option.serverCycle,
        orderEndTime: '',
        orderId: '',
        orderIsDelete: '',
        orderName: this.serviceDetail.serverName,
        orderOperator: this.$store.getters.userInfo.merchantName,
        orderPrice: option.serverPrice,
        orderTime: '',
        orderVersion: this.serviceDetail.serverPrices[this.server].serverVersion,
        payStatus: '',
        platformId: this.getPlatformConfig().platformId,
        serverId: this.serviceDetail.serverId,
        serverUniqueId: this.serviceDetail.serverUniqueId
      })
        .then(res => {
          this.orderId = res
          this.visible = true
          this.getPayImg()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取微信图片
    getPayImg() {
      let url = `weixin/weiXinQrCodePay?orderId=${this.orderId}`
      this.imgPath = this.getAppConfig().serviceUrl + url
      this.timeout()
    },
    // 获取支付状态
    getPayStatus() {
      this.getHttpServices().getServerApiService().get('order/getPayStatus?orderId=' + this.orderId)
        .then(res => {
          if (res) {
            this.clearTimeout()
            this.visible = false
            this.$message.success('购买成功')
          }
        })
        .catch(err => {
          this.getLogUtils().logWithTag('错误', err)
        })
    },
    // 支付回调监听
    timeout() {
      this.timer = setInterval(this.getPayStatus, 1000)
    },
    // 清除定时器
    clearTimeout() {
      clearInterval(this.timer)
      this.timer = null
    },
    changeServerVersion(index) {
      this.server = index
      this.ser = 0
      if (this.serviceDetail.serverPrices[this.server]) {
        if (this.serviceDetail.serverPrices[this.server].serverPriceAndCycles[this.ser].serverPrice !== undefined) {
          this.totalPrice = this.serviceDetail.serverPrices[this.server].serverPriceAndCycles[this.ser].serverPrice
        }
      }
    },
    changeServerCycle(index) {
      this.ser = index
      if (this.serviceDetail.serverPrices[this.server]) {
        if (this.serviceDetail.serverPrices[this.server].serverPriceAndCycles[this.ser].serverPrice !== undefined) {
          this.totalPrice = this.serviceDetail.serverPrices[this.server].serverPriceAndCycles[this.ser].serverPrice
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "../CustomPage";

.detail-image {
  height: 200px;
  width: 200px;
  margin-right: 20px;
  float: left;
}

.s-detail-content-box {
  float: left;
  width: 60%;

  .title {
    height: 16px;
    line-height: 16px;
    font-size: 16px;
    font-weight: bold;
    color: #444444;
    .single-line();
  }

  .content-text {
    margin-top: 10px;
    color: #8f8f8f;
    line-height: 20px;
    font-size: 16px;
    width: 400px;
  }

  .price {
    margin-top: 10px;
    height: 14px;
    line-height: 14px;
    color: red;
  }

  .item-name {
    color: #444444;
    margin-right: 10px;
  }
}

.imgCode {
  width: 250px;
  height: 250px;
  display: block;
  margin: 20px auto;
}

.imgText {
  text-align: center;
}


</style>